/**
 *@author lxl
 * @description 天正数据加工
 * @type {{parseData: ((datelist, eId))}}
 */

import func from "./func";
import * as echarts from 'echarts';
const tzUtil = {
    // 2019-05-16 2019-05-16 lxl  天正传感器分类
    tzSensorCatId: '20181217151828yraPJcuH',
    myColor: ['#66AEDE', '#f391a9', '#faa755', '#45b97c'],
    getRecord(dateList, eId, factoryType, deviceName){
        var tempList = [];
        var xIndex = [];
        var params = {};
        // 数据格式{"create_date":1555344035000,"val":"0.56","notice":null,"create_date_format":"2019年04月16日 00:00:35"}
        if (eId == '24') {// 天正水位
            var data = func.sensorData(eId, factoryType)[0];
            var name = data.name, union = data.union;
            // 1个小时取两个数据 即隔30分钟取一个
            for (var i = 0; i < dateList.length; i = i + 30) {
                tempList.push(parseFloat(dateList[i].val));
                xIndex.push(tzUtil.getDate(dateList[i].create_date))
            }
            ;
            params = {
                datas: [],
                xIndex: [],
            };
            params.xIndex = xIndex;
            params.datas = tempList
            var option = {
                title: {
                    text: deviceName + '-历史记录',
                    textStyle: {color: '#ccc'}
                },
                // 定义样式和数据
                backgroundColor: 'rgba(200, 200, 200, 0.1)',
                tooltip: {
                    trigger: 'axis'
                },
                dataZoom: [{
                    type: 'slider',
                    show: true, //flase直接隐藏图形
                    xAxisIndex: [0],
                    left: '9%', //滚动条靠左侧的百分比
                    bottom: -5,
                    start: 0,//滚动条的起始位置
                    end: 20, //滚动条的截止位置（按比例分割你的柱状图x轴长度）
                    dataBackgroundColor: '#fbfbfb',
                    textStyle: {color: '#fbfbfb'}
                }],
                legend: {
                    data: [name],
                    textStyle: {color: '#fbfbfb'}
                },
                calculable: true,
                xAxis: [{
                    // axisLabel: {
                    //     fontSize:11,
                    //     rotate: 0,// label的倾斜角
                    //     interval: 0
                    // },
                    axisLine: {
                        lineStyle: {
                            color: '#fbfbfb'
                        }
                    },
                    type: 'category',
                    boundaryGap: false,
                    data: params.xIndex
                }],
                yAxis: [{
                    name: name + '(' + union + ')',
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: '#fbfbfb'
                        }
                    }
                }],
                series: [{
                    name: name,
                    type: 'line',
                    symbol: 'none',
                    smooth: 0.3,
                    itemStyle: {normal: {areaStyle: {type: 'default'}}},
                    color: ['#66AEDE'],
                    data: params.datas
                }]
            };
        } else if (eId == '4') {//温湿盐
            return tzUtil.getWsyData(dateList, deviceName);
        } else if (eId.indexOf('sensor') !== -1) {//精讯、芯蚁
            var sdata = func.sensorData(eId, factoryType);
            console.log(sdata)
            sdata.map(function (item, index) {
                tempList.push([])
            })
            if (factoryType == 5) {//精讯
                var wire = eid.split('-')[2];
                // 数据转换,设备在第几路就取第几位的数据
                for (var i = 0; i < dateList.length; i++) {
                    var sensorData = dateList[i].sensorData.replace(/\s*/g, "").split('|')
                    sdata.map(function (item, index) {
                        tempList[index].push(parseFloat(sensorData[wire - 1]));
                    })
                    xIndex.push(dateList[i].drecordTime.substr(5, 15))
                }
            } else if (factoryType == 6) {//芯蚁
                for (var i = 0; i < dateList.length; i++) {
                    sdata.map(function (item, index) {
                        tempList[index].push(parseFloat(dateList[i].rawData[item.index]));
                    })
                    xIndex.push(dateList[i].gmtCreate.substr(5, 15))
                }
            }
            ;
            params = {
                datas: [],
                xIndex: [],
            };

            params.xIndex = xIndex;
            params.datas = tempList
            var name = [], yAxisData = [], seriesData = [];
            sdata.map(function (item, index) {
                name.push(item.name);
                yAxisData.push({
                    name: item.name + '(' + item.union + ')',
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: tzUtil.myColor[index],
                            fontSize: 5
                        }
                    }
                });
                seriesData.push({
                        name: item.name,
                        type: 'line',
                        symbol: 'none',
                        smooth: 0.3,
                        itemStyle: {normal: {areaStyle: {type: 'default'}}},
                        color: tzUtil.myColor[index],
                        data: params.datas[index],
                    }
                );
            });
            var option = {
                title: {
                    top: 12,
                    left: 2,
                    text: deviceName + '-历史记录',
                    textStyle: {
                        fontSize: 10,
                        color: '#28EDF8'
                    }
                },
                // 定义样式和数据
                backgroundColor: 'rgba(200, 200, 200, 0.1)',
                tooltip: {
                    trigger: 'axis'
                },
                dataZoom: [{
                    type: 'slider',
                    show: true, //flase直接隐藏图形
                    xAxisIndex: [0],
                    left: '9%', //滚动条靠左侧的百分比
                    bottom: -5,
                    start: 0,//滚动条的起始位置
                    end: 20,//滚动条的截止位置（按比例分割你的柱状图x轴长度）
                    dataBackgroundColor: '#28EDF8',
                    textStyle: {color: '#28EDF8'}
                }],
                legend: {
                    data: name,
                    textStyle: {color: '#28EDF8'}
                },
                calculable: true,
                xAxis: [{
                    // axisLabel: {
                    //     fontSize:11,
                    //     rotate: 0,// label的倾斜角
                    //     interval: 0
                    // },
                    axisLine: {
                        lineStyle: {
                            color: '#28EDF8'
                        }
                    },
                    type: 'category',
                    boundaryGap: false,
                    data: params.xIndex
                }],
                yAxis: yAxisData,
                series: seriesData
            };
        }
        return option;
    },
    dapingGetRecord(dateList, eId, factoryType, deviceName,index){
        var tempList = [];
        var xIndex = [];
        var params = {};
        // 数据格式{"create_date":1555344035000,"val":"0.56","notice":null,"create_date_format":"2019年04月16日 00:00:35"}
        if (eId == '24') {// 天正水位
            var data = func.sensorData(eId, factoryType)[0];
            var name = data.name, union = data.union;
            // 1个小时取1个数据 即隔60分钟取一个
            for (var i = 0; i < dateList.length; i = i + 60) {
                tempList.push(parseFloat(dateList[i].val));
                xIndex.push(tzUtil.getDate(dateList[i].create_date))
            }
            ;
            params = {
                datas: [],
                xIndex: [],
            };
            params.xIndex = xIndex;
            params.datas = tempList
            var option = {
                title: {
                    text: deviceName + '-历史记录',
                    textStyle: {color: '#ffffff'}
                },
                // 定义样式和数据
                backgroundColor: 'rgba(200, 200, 200, 0.1)',
                tooltip: {
                    trigger: 'axis'
                },
                dataZoom: [{
                    type: 'slider',
                    show: flase, //flase直接隐藏图形
                    xAxisIndex: [0],
                    left: '9%', //滚动条靠左侧的百分比
                    bottom: -5,
                    start: 0,//滚动条的起始位置
                    end: 100, //滚动条的截止位置（按比例分割你的柱状图x轴长度）
                    dataBackgroundColor: '#fbfbfb',
                    textStyle: {color: '#fbfbfb'}
                }],
                legend: {
                    data: [name],
                    textStyle: {color: '#fbfbfb'}
                },
                calculable: true,
                xAxis: [{
                    // axisLabel: {
                    //     fontSize:11,
                    //     rotate: 0,// label的倾斜角
                    //     interval: 0
                    // },
                    axisLine: {
                        lineStyle: {
                            color: '#fbfbfb'
                        }
                    },
                    type: 'category',
                    boundaryGap: false,
                    data: params.xIndex
                }],
                yAxis: [{
                    name: name + '(' + union + ')',
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: '#fbfbfb'
                        }
                    }
                }],
                series: [{
                    name: name,
                    type: 'line',
                    symbol: 'none',
                    smooth: 0.3,
                    itemStyle: {normal: {areaStyle: {type: 'default'}}},
                    color: ['#66AEDE'],
                    data: params.datas
                }]
            };
        } else if (eId == '4') {//温湿盐
            return tzUtil.getWsyData(dateList, deviceName);
        } else if (eId.indexOf('sensor') !== -1) {//精讯、芯蚁
            var sdata = func.sensorData(eId, factoryType);
            console.log(sdata)
            sdata.map(function (item, index) {
                tempList.push([])
            })
            if (factoryType == 5) {//精讯
                var wire = eid.split('-')[2];
                // 数据转换,设备在第几路就取第几位的数据
                for (var i = 0; i < dateList.length; i = i + 24) {
                    var sensorData = dateList[i].sensorData.replace(/\s*/g, "").split('|')
                    sdata.map(function (item, index) {
                        tempList[index].push(parseFloat(sensorData[wire - 1]));
                    })
                    xIndex.push(dateList[i].drecordTime.substr(5, 5))
                }
            } else if (factoryType == 6) {//芯蚁
                for (var i = 0; i < dateList.length; i = i + 24) {
                    sdata.map(function (item, index) {
                        tempList[index].push(parseFloat(dateList[i].rawData[item.index]));
                    })
                    xIndex.push(dateList[i].gmtCreate.substr(5, 5))
                }
            }
            ;
            params = {
                datas: [],
                xIndex: [],
            };
            params.xIndex = xIndex;
            params.datas = tempList
            var name = [], yAxisData = [], seriesData = [];
            sdata.map(function (item, index) {
                name.push(item.name);
                yAxisData.push({
                    // name: item.name + '(' + item.union + ')',
                    type: 'value',
                    nameGap:3,
                    nameTextStyle:{
                        align:'left',
                        lineHeight:10,
                        height:10,
                        fontSize: 8
                    },
                    axisTick: {
                        inside: true
                    },
                    axisLabel: {
                        inside: true,//刻度标签是否朝内
                    },
                    axisLine: {
                        lineStyle: {
                            bottom: 0,
                            color: tzUtil.myColor[index],
                            fontSize: 5
                        }
                    }
                });
                seriesData.push({
                        name: item.name,
                        type: 'line',
                        smooth: true,
                        symbol: 'none',
                    areaStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: 'rgba(40,237,248,0.8)'
                            },
                            {
                                offset: 1,
                                color: 'rgba(40,237,248,0.2)'
                            }
                        ])
                    },
                        data: params.datas[index],
                    }
                );
            });
            var option = {
                title: {
                    top: index<1?150:110,//左右显示的高度不同
                    left: 'center',
                    text: deviceName + '-历史记录',
                    textStyle: {
                        lineHeight:2,
                        height:10,
                        fontSize: 10,
                        color: '#ffffff'
                    }
                },
                // 定义样式和数据
                backgroundColor: 'rgba(200, 200, 200, 0)',
                tooltip: {
                    trigger: 'axis'
                },
                dataZoom: [{
                    type: 'inside',
                    throttle: 50
                    // show: true, //flase直接隐藏图形
                    // xAxisIndex: [0],
                    // left: '9%', //滚动条靠左侧的百分比
                    // height:0,
                    // bottom: 0,
                    // start: 0,//滚动条的起始位置
                    // end: 100,//滚动条的截止位置（按比例分割你的柱状图x轴长度）
                    // dataBackgroundColor: '#28EDF8',
                    // textStyle: {color: '#28EDF8'}
                }],
                legend: {
                    data: name,
                    textStyle: {color: '#28EDF8'}
                },
                calculable: true,
                grid: {
                    top: 18,
                    left: 10,
                    right: 10,
                    bottom:0,
                    height: index<1?110:75
                },
                xAxis: [{
                    // position:'bottom',
                    axisLabel: {
                        fontSize:8,
                    },
                    type: 'category',
                    data: params.xIndex,
                    axisPointer: {
                        lineStyle: {
                            color: '#28EDF8',
                            width: 0.5,
                            fontSize:6,
                        },
                        label: {
                            show: false,
                            backgroundColor: '#28EDF8'
                        },

                    },
                    splitLine: {
                        show: false
                    }
                }],
                yAxis: yAxisData,
                series: seriesData
            };
        }
        return option;
    },
    //数据格式 {"create_date":1558009427000,"val":"0.531,21.1,0.094","notice":null,"create_date_format":"2019年05月16日 20:23:47"}
    getWsyData(dateList, deviceName){
        var wList = [];// 温度
        var sList = [];// 湿度
        var yList = [];// 盐度


        var xIndex = [];
        // 1个小时取两个数据 即隔30分钟取一个
        for (var i = 0; i < dateList.length; i = i + 30) {
            var temp = dateList[i].val.split(',');
            sList.push(parseFloat(temp[0] * 100));
            wList.push(parseFloat(temp[1]));
            yList.push(parseFloat(temp[2]));

            xIndex.push(tzUtil.getDate(dateList[i].create_date))
        }
        ;
        console.log("为温度历史数据")
        console.log(JSON.stringify(wList))
        console.log("为湿度历史数据")
        console.log(JSON.stringify(sList))
        console.log("为盐度历史数据")
        console.log(JSON.stringify(yList))
        return {
            title: {
                text: deviceName + '-历史记录',
                textStyle: {color: '#fbfbfb'}
            },
            // 定义样式和数据
            backgroundColor: 'rgba(200, 200, 200, 0.1)',
            tooltip: {
                trigger: 'axis'
            },
            dataZoom: [{
                type: 'slider',
                show: true, //flase直接隐藏图形
                xAxisIndex: [0],
                left: '9%', //滚动条靠左侧的百分比
                bottom: -5,
                start: 0,//滚动条的起始位置
                end: 10, //滚动条的截止位置（按比例分割你的柱状图x轴长度）
                dataBackgroundColor: '#fbfbfb',
                textStyle: {color: '#fbfbfb'}
            }],
            legend: {
                data: ['温度', '湿度', '盐度'],
                textStyle: {color: '#fbfbfb'}
            },
            calculable: true,
            xAxis: [{
                axisLine: {
                    lineStyle: {
                        color: '#fbfbfb'
                    }
                },
                type: 'category',
                boundaryGap: false,
                data: xIndex
            }],
            yAxis: [{
                name: '温度(℃)',
                type: 'value',
                axisLine: {
                    lineStyle: {
                        color: '#FF0000'
                    }
                }
            }, {
                name: '湿度(%RH)',
                type: 'value',
                nameLocation: 'center',
                axisLine: {
                    lineStyle: {
                        color: '#66AEDE'
                    }
                }
            }, {
                name: '盐度(us/cm)',
                type: 'value',
                nameLocation: 'end',
                axisLine: {
                    lineStyle: {
                        color: '#FF7F00'
                    }
                }
            }],
            series: [{
                name: '温度',
                type: 'line',
                symbol: 'none',
                smooth: 0.3,
                itemStyle: {normal: {areaStyle: {type: 'default'}}},
                color: ['#FF0000'],
                data: wList
            }, {
                name: '湿度',
                type: 'line',
                symbol: 'none',
                smooth: 0.3,
                itemStyle: {normal: {areaStyle: {type: 'default'}}},
                color: ['#66AEDE'],
                data: sList
            }, {
                name: '盐度',
                type: 'line',
                symbol: 'none',
                smooth: 0.3,
                itemStyle: {normal: {areaStyle: {type: 'default'}}},
                color: ['#FF7F00'],
                data: yList
            }]
        };
    },

    getDate(timesnap){
        var date = new Date(timesnap);
        return tzUtil.format2(date.getMonth() + 1)
            + '-' + tzUtil.format2(date.getDate()) + ' '
            + tzUtil.format2(date.getHours()) + ':'
            + tzUtil.format2(date.getMinutes());
    },

    /**
     * 补零
     * @param val
     * @returns {*}
     */
    format2(val){
        if (val < 10) {
            val = '0' + val
        }
        return val
    },
}
export default tzUtil;

